import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class RequestResponseService {
  private requestSubject = new Subject<{ id: string; payload?: any }>();
  request$ = this.requestSubject.asObservable();

  private responseSubject = new Subject<{ id: string; data: any }>();
  response$ = this.responseSubject.asObservable();

  sendRequest(id: string, payload?: any) {
    this.requestSubject.next({ id, payload });
  }

  sendResponse(id: string, data: any) {
    this.responseSubject.next({ id, data });
  }
}
